module.exports = __webpack_public_path__ + "media/images/iconDelete__accent--dark-65675c24fcb49e21627fcda1db0921fb.png";